<template>
  <div class="cooperation_application">
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" show-overflow-tooltip width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="name" label="公司名称"></el-table-column>
        <el-table-column show-overflow-tooltip label="logo">
          <template slot-scope="scope">
            <span style="color: #0096ff; cursor: pointer" @click="previewImage(scope.row.logoUrl)">查看图片</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="introduction" label="简介"></el-table-column>
        <el-table-column show-overflow-tooltip prop="address" label="公司地址"></el-table-column>
        <el-table-column show-overflow-tooltip prop="contactTel" label="服务热线"></el-table-column>
        <el-table-column show-overflow-tooltip prop="contactEmail" label="联系邮箱"></el-table-column>
        <el-table-column show-overflow-tooltip label="企微二维码">
          <template slot-scope="scope">
            <span style="color: #0096ff; cursor: pointer" @click="previewImage(scope.row.qrCode)">查看图片</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="updatedTime" label="更新时间"></el-table-column>
        <el-table-column show-overflow-tooltip label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row, 1)">修改</el-button>
            <!-- <el-button type="danger" plain @click="handleDel(scope.row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <el-dialog :title="add == 0 ? '新增' : '编辑'" :visible.sync="dialogVisible" :before-close="onCancel">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="230px" class="ruleForm">
        <div class="el_upload__tip">
          <i class="el-icon-warning"></i>
          <span>请确保项目图片信息清晰可见，图片格式仅支持jpg、jpeg、png，图片大小不超过5MB。</span>
        </div>
        <div style="display: flex; justify-content: flex-start">
          <el-form-item label="logo" prop="logoUrl" style="width: 45%">
            <el-upload ref="upload" class="upload-demo" accept=".png,.jpeg,.jpg" :file-list="logoUrlList" :limit="1" name="multipartFile" :headers="headers" :action="action" :on-success="busiLicenseSuccess" :before-upload="beforeUploads" :on-remove="handleRemove" list-type="picture">
              <el-button type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="企微二维码" prop="qrCode" style="width: 45%">
            <el-upload ref="upload1" class="upload-demo" accept=".png,.jpeg,.jpg" :file-list="fileList" :limit="1" name="multipartFile" :headers="headers" :action="action" :on-success="busiLicenseSuccess1" :before-upload="beforeUploads" :on-remove="handleRemove1" list-type="picture">
              <el-button type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </div>
        <el-form-item label="公司名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入公司名称"></el-input>
        </el-form-item>
        <el-form-item label="公司地址" prop="address">
          <el-input v-model="ruleForm.address" placeholder="请输入公司地址"></el-input>
        </el-form-item>
        <el-form-item label="服务热线" prop="contactTel">
          <el-input v-model="ruleForm.contactTel" placeholder="请输入服务热线"></el-input>
        </el-form-item>
        <el-form-item label="联系邮箱" prop="contactEmail">
          <el-input v-model="ruleForm.contactEmail" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="简介" prop="introduction">
          <el-input type="textarea" placeholder="请输入简介" :autosize="{ minRows: 5, maxRows: 10 }" v-model="ruleForm.introduction" maxlength="200" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
    <el-image-viewer
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false
        }
      "
      :url-list="imgList"
    ></el-image-viewer>
  </div>
</template>

<script>
export default {
  components: {
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer"),
  },
  data() {
    return {
      // 图片预览
      showViewer: false,
      imgList: [],
      add: 0,
      headers: { token: this.$store.state.token },
      action: this.$axios.defaults.baseURL + this.$api.uploadFile,
      fileList: [],
      logoUrlList: [],
      dialogVisible: false,
      tableData: [],
      titleName: "",
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
      ruleForm: {
        logoUrl: "", //logoUrl
        qrCode: "", //企微二维码
        name: "", //公司名称
        address: "", //公司地址
        contactTel: "", //服务热线
        contactEmail: "", //联系邮箱
        introduction: "", //简介
      },
      rules: {
        qrCode: [{ required: true, message: "缺少企微二维码", trigger: "blur" }],
        logoUrl: [{ required: true, message: "缺少logo", trigger: "blur" }],
        name: [{ required: true, message: "缺少公司名称", trigger: "blur" }],
        address: [{ required: true, message: "缺少公司地址", trigger: "blur" }],
        contactTel: [
          { required: true, message: "缺少服务热线", trigger: "blur" },
          { pattern: /^[0-9]*$/, message: "号码格式不正确", trigger: "blur" },
        ],
        introduction: [{ required: true, message: "缺少简介", trigger: "blur" }],
        contactEmail: [
          { required: true, message: "缺少邮箱", trigger: "blur" },
          { pattern: /^([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/, message: "邮箱格式不正确", trigger: "blur" },
          // {
          //   validator: (rule, value, callback) => {
          //     // 只有在值不为空时才发起请求验证手机号是否已存在
          //     if (value) { // 快速正则匹配手机号格式
          //       // 校验手机号是否已被注册
          //       this.iconLoading = true
          //       this.$axios.get(`${this.$api.contactTel}/${value}`).then((res) => {
          //         // 如果响应-1 表示该手机号已存在
          //         console.log(res);
          //         const { code, desc } = res
          //         if (code == -1 || code == 900) {
          //           callback(new Error(desc));
          //         } else {
          //           callback(); // 手机号可以使用，通过校验
          //         }
          //       }).catch((error) => {
          //         this.iconLoading = false
          //         console.error('校验手机号是否存在时发生错误:', error);
          //         callback(new Error(error.desc)); // 出错时也可以先通过校验，后续处理错误或给用户友好提示
          //       });
          //     } else {
          //       callback(); // 手机号格式不正确，不过这里仍通过校验，因为前面应该已经有关于手机号格式的规则校验
          //     }
          //   },
          //   trigger: 'blur'
          // }
        ],
      },
    }
  },
  created() {
    this.selectEnterpriseInfoList()
  },
  methods: {
    // 图片放大
    previewImage(url) {
      this.imgList[0] = url
      this.showViewer = true
    },
    // // 删除
    // handleDel(row) {
    //   this.$axios.post(this.$api.bannerDelete, {
    //     id: row.id,
    //     bizType: row.bizType,
    //   }).then((res) => {
    //     this.selectEnterpriseInfoList();
    //     this.$message({
    //       message: res.desc,
    //       type: "success",
    //     })
    //   }).catch(err => {
    //     this.$message({
    //       message: err.desc,
    //       type: 'error'
    //     })
    //   })
    // },
    // 新增
    handladd(index) {
      this.add = index
      this.dialogVisible = true
    },
    // 编辑
    handleEdit(row, index) {
      this.add = index
      let data = Object.assign({}, row)
      this.ruleForm.address = data.address
      this.ruleForm.contactEmail = data.contactEmail
      this.ruleForm.contactTel = data.contactTel
      this.ruleForm.introduction = data.introduction
      this.ruleForm.name = data.name
      this.ruleForm.id = data.id
      this.fileList = [{ url: data.qrCode }]
      this.logoUrlList = [{ url: data.logoUrl }]
      this.ruleForm.logoUrl = data.logoUrl
      this.ruleForm.qrCode = data.qrCode
      this.dialogVisible = true
    },
    // 发布
    submitForm(ruleForm) {
      // this.ruleForm = {
      //   address: this.ruleForm.address,//公司地址
      //   contactEmail: this.ruleForm.contactEmail,//联系邮箱
      //   contactTel: this.ruleForm.contactTel,//服务热线
      //   introduction: this.ruleForm.introduction,//简介
      //   name: this.ruleForm.name,//公司名称
      //   id: this.ruleForm.id,
      // }
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          this.$axios
            .post(this.$api.updateEnterpriseInfo, this.ruleForm)
            .then(res => {
              this.selectEnterpriseInfoList()
              this.onCancel()
              this.$message({
                message: res.desc,
                type: "success",
              })
            })
            .catch(err => {
              this.$message({
                message: err.desc,
                type: "error",
              })
            })
        } else {
          return false
        }
      })
    },
    onCancel() {
      this.dialogVisible = false
      // this.ruleForm = {}
      this.$refs.upload.clearFiles()
      this.$refs.upload1.clearFiles()
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 删除营业执照
    handleRemove() {
      this.$refs.upload.clearFiles()
    },
    // 删除营业执照
    handleRemove1() {
      this.$refs.upload1.clearFiles()
    },
    // 项目图片上传成功
    busiLicenseSuccess(res) {
      if (res.code == 100) {
        this.ruleForm.logoUrl = res.result.fileUrl
        console.log("logoUrl", this.ruleForm.logoUrl)
      } else {
        this.$message({ showClose: true, message: res.desc, type: "error" })
      }
    },
    // 项目图片上传成功
    busiLicenseSuccess1(res) {
      if (res.code == 100) {
        this.ruleForm.qrCode = res.result.fileUrl
        console.log("qrCode", this.ruleForm.qrCode)
      } else {
        this.$message({ showClose: true, message: res.desc, type: "error" })
      }
    },
    // 文件上传
    beforeUploads(file) {
      const isJPG = file.type === "image/jpeg" || "image/jpg" || "image/png"
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.$message.error("图文只支持jpg、png、jpeg，请调整格式再上传!")
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!")
      }
      return isJPG && isLt5M
    },
    // 获取列表
    selectEnterpriseInfoList() {
      let params = {
        page: this.currentPage,
        pageSize: this.pageSize,
      }
      this.$axios
        .get(this.$api.selectEnterpriseInfoList, { params })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list
            this.totalItemsCount = res.result.totalCount
          }
        })
        .catch(err => {
          this.$message({
            message: err.desc,
            type: "error",
          })
        })
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.selectEnterpriseInfoList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.selectEnterpriseInfoList()
    },
  },
}
</script>

<style scoped lang="scss">
.cooperation_application {
  .el_upload__tip {
    text-align: center;
    margin-bottom: 20px;
  }
  ::v-deep .el-dialog__headerbtn {
    top: 16px;
  }
  ::v-deep .el-dialog .el-dialog__header {
    padding: 11px 20px !important;
  }
  .el-icon-warning {
    color: #0096ff;
    font-size: 16px;
  }
  ::v-deep .el-upload-list {
    width: 30% !important;
  }
  ::v-deep .el-dialog .el-input__inner {
    width: 520px !important;
  }

  .el-textarea {
    width: 92% !important;
  }
  ::v-deep .el-input__count {
    background: transparent !important;
  }
}
</style>
